<template>
  <div>
    <div class="d-flex flex-row mb-2">
      <p class="text-2xl mb-2">Liste des groupes de vues de partenaires</p>
      <v-col class="text-right">
        <v-btn color="primary" :to="{ name: 'partner-view-group-edit' }">
          <v-icon class="mr-3">{{ icons.mdiPencilBox }}</v-icon
          >Ajouter une vue de partenaires</v-btn
        >
      </v-col>
    </div>
    <v-card>
      <v-card-title class="align-start">
        <v-text-field
          v-model="search"
          :append-icon="icons.mdiMagnify"
          label="Recherche... "
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :page="options.page"
          :pageCount="numberOfPages"
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="options.total"
          :loading="loading"
          :sort-by="'ca'"
          :sort-desc="true"
          class="elevation-1"
          :search="search"
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
          }"
          :items-per-page="options.itemsPerPage"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              :href="`/partner-view-group/edit/${item.id}`"
              target="_blank"
              class="mx-2"
              elevation="0"
              fab
              small
            >
              <v-icon color="primary">
                {{ icons.mdiPencil }}
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              elevation="0"
              fab
              small
              @click.native="
                dialogModel.dialog = !dialogModel.dialog;
                dialogModel.id = item.id;
                dialogModel.name = item.name;
              "
            >
              <v-icon color="secondary">
                {{ icons.mdiTrashCan }}
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-dialog v-model="dialogModel.dialog" width="70vw">
        <del-confirmation
          :dialogOpen="dialogModel.dialog"
          :id="dialogModel.id"
          :name="dialogModel.name"
          @openDialog="openDialog"
        ></del-confirmation>
      </v-dialog>
    </v-card>
  </div>
</template>
<style scoped></style>
<script>
import DelConfirmation from "@/components/common/modals/GroupPartnerViewDelConfirmation";
import axios from "@axios";
import { mdiMagnify, mdiPencil, mdiTrashCan } from "@mdi/js";

export default {
  name: "List",
  components: { DelConfirmation },
  data() {
    return {
      search: "",
      numberOfPages: 0,
      items: [],
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 10,
        total: 0,
      },
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Groupe de 'vues de partenaires'",
          value: "name",
        },
        {
          text: "Code",
          value: "code",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],
      dialogModel: {
        dialog: false,
        id: -1,
        name: "",
      },
      icons: {
        mdiMagnify,
        mdiPencil,
        mdiTrashCan,
      },
    };
  },
  watch: {
    // options: {handler(){this.updateData();}, deep:true,},
    // individual properties to avoid refreshing when options.total updates
    "options.itemsPerPage"() {
      this.updateData();
    },
    "options.page"() {
      this.updateData();
    },
    "options.sortBy"() {
      this.updateData();
    },
    "options.sortDesc"() {
      this.updateData();
    },
    search() {
      this.options.page = 1;
      this.updateData();
    },
  },
  methods: {
    async updateData() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const queryParams = {
        page: page - 1,
        limit: itemsPerPage,
        ...(this.search ? { search: this.search } : {}),
        ...(sortBy && sortDesc && sortBy.length > 0 && sortDesc.length > 0
          ? {
              sort_by: sortBy[0],
              sort_desc: sortDesc[0],
            }
          : {}),
      };

      const { data } = await axios.get("/partner-view-groups/", {
        params: queryParams,
      });

      this.loading = false;
      this.items = data.items;
      this.options.total = data.total;
      this.numberOfPages = data.total / this.options.itemsPerPage;
    },
    openDialog(value) {
      this.dialogModel.dialog = value;
      this.updateData();
    },
  },
  mounted() {
    this.updateData();
  },
};
</script>
